<template>
    <modal show-on-mount size="large" @hide="hide()">
        <template slot="modal-body">
            <touchpoint-overview
                :brick-id="brickId"
                :name="brickName"
                :type="brickType"
                :config="brickConfig"
                :disable-statistics="brickIsNew"

                :incoming-connections-info="IncomingConnectionsInfo"
                :outgoing-connections-info="OutgoingConnectionsInfo"
                :initial-tab="initialTab"
            />
        </template>

        <template slot="modal-footer">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-secondary btn-lg" @click="hide()">
                        <i class="fas fa-check-circle"/>&nbsp;&nbsp;{{resource('Button_OK')}}
                    </button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';

    import resourceMixin from "@core/Util/Mixins/resources";

    import Modal from '@core/Components/Util/Modal.vue'
    import {default as TouchpointOverview, defaultTab} from "./TouchpointOverview.vue";
    
    const {mapState} = createNamespacedHelpers('journeyBuilder/composer');
    
    export default {
        name: 'journey-builder-composer-touchpoint-overview',
        components: {
            Modal,
            TouchpointOverview
        },
        mixins: [resourceMixin],
        computed: {
            ...mapState(['brickMap']),
            popup(){
                return this.$refs.popup;
            },
            brickIsNew(){
                return this.brickMap[this.brickId].isNew;
            }
        },
        methods: {
            show(tab){
                if(tab){
                    this.initialTab = tab;
                }
                
                this.popup.show();
            },
            hide(){
                this.$emit('hide');
            }
        },
        props: {
            brickId: {
                type: String,
                required: true
            },
            brickName: {
                type: String,
                required: true
            },
            brickType: {
                type: Number,
                required: true
            },
            brickConfig: {
                type: Object,
                required: true
            },

            IncomingConnectionsInfo: {
                type: Array,
                required: true
            },
            OutgoingConnectionsInfo: {
                type: Array,
                required: true
            }
        },
        data: () => ({
            initialTab: defaultTab
        })
    }
</script>